import React, { useEffect, useState, useRef } from 'react';
import img from '../assets/nav-logo.webp';

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const menuRef = useRef(null); // 🆕

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 992) {
                setIsMenuOpen(false); // close menu on large screens
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target)
            ) {
                setIsMenuOpen(false);
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(prev => !prev);
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(prev => !prev);
    };

    return (
        <>
            <div className="topNav">
                <a href="javascript:void(0)" className="landing-slider-button">
                    10-Day Free Trial – Get Started
                </a>
            </div>
            <nav className={`navbar navbar-expand-lg bg-body-tertiary ${scrolled ? 'navbar-scrolled' : ''}`}>
                <div className="container" ref={menuRef}>
                    <a className="navbar-brand" href="/">
                        <img src={img} alt="Navbar Logo" />
                    </a>
                    <div className="d-flex align-items-center gap8">
                        <button className="btn btn-login btn-loginMobile d-none" type="submit">Login</button>
                        <button
                            className={`navbar-toggler ${isMenuOpen ? 'show' : ''}`}
                            type="button"
                            onClick={toggleMenu}
                            aria-controls="navbarSupportedContent"
                            aria-expanded={isMenuOpen}
                            aria-label="Toggle navigation"
                        >
                            {isMenuOpen ? (
                                <span className="navbar-toggler-cross" style={{ fontSize: '28px', lineHeight: '1' }}>&times;</span>
                            ) : (
                                <span className="navbar-toggler-icon"></span>
                            )}
                        </button>
                    </div>
                    <div
                        className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}
                        id="navbarSupportedContent"
                    >
                        <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <a className="nav-link active" aria-current="page" href="/">Home</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://poolwater-pro.com/#about-us">About Us</a>
                            </li>
                            <li className="nav-item dropdown" ref={dropdownRef}>
                                <a
                                    className="nav-link dropdown-toggle d-flex align-items-center"
                                    href="#"
                                    role="button"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggleDropdown();
                                    }}
                                    aria-expanded={isDropdownOpen}
                                >
                                    Troubleshooting Guides
                                </a>
                                <ul className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`}>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/why-is-my-pool-green/">Why is My Pool Green?</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/how-to-add-chemicals-to-your-pool/">How to Add Chemicals to Your Pool</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/green-pool-causes-fixes/">Green Pool Causes &amp; Fixes</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/comprehensive-guide-to-pool-chemicals/">Comprehensive Guide to Pool Chemicals</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/chlorinator-selection-guide-for-swimming-pools/">Chlorinator Selection Guide for Swimming Pools</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/managing-chlorine-levels-in-swimming-pools/">Managing Chlorine Levels in Swimming Pools</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/media-filter-sand-filter-and-cartridge-filter-comparison/">Media Filter (Sand Filter) and Cartridge Filter Comparison</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/how-often-should-i-clean-my-pool/">How Often Should I Clean My Pool?</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/what-is-alkalinity-and-how-to-adjust-it/">What is Alkalinity and How to Adjust It</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/using-muriatic-acid-hydrochloric-acid-or-sodium-bisulphate-in-pool-maintenance/">Using Muriatic Acid, Hydrochloric Acid or Sodium Bisulphate in Pool Maintenance</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/understanding-and-managing-cyanuric-acid-levels-in-pools/">Understanding and Managing Cyanuric Acid Levels in Pools</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/monitoring-salinity-levels-in-swimming-pools/">Monitoring Salinity Levels in Swimming Pools</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/how-do-i-vacuum-my-pool/">How Do I Vacuum My Pool</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/managing-total-hardness-amp-calcium-hardness/">Managing Total Hardness &amp; Calcium Hardness</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/how-to-clean-a-green-pool-in-24-hours/">How to Clean a Green Pool in 24 Hours</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/resolving-pool-pump-priming-issues/">Resolving Pool Pump Priming Issues</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/is-it-safe-for-swimming-with-high-chlorine/">Is it Safe for Swimming with High Chlorine</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/what-is-the-best-way-to-heat-a-pool/">What is the Best Way to Heat a Pool</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/do-i-still-need-to-add-chemicals-to-my-pool-during-winter/">Do I Still Need to Add Chemicals to My Pool During Winter</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/understanding-the-functions-of-your-pool-equipment/">Understanding the Functions of Your Pool Equipment</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/is-your-pool-safe-for-swimming/">Is Your Pool Safe for Swimming?</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/dynamics-of-pool-water-chemistry/">Dynamics of Pool Water Chemistry</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/how-to-keep-ducks-out-of-my-pool/">How to Keep Ducks Out of My Pool</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/how-often-should-i-test-my-pool-water/">How Often Should I Test My Pool Water</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/how-to-lower-ph-in-your-pool/">How to Lower pH in Your Pool</a></li>
                                <li><a class="dropdown-item dropdown-item-nav" href="https://dev.poolwater-pro.com/do-pool-test-strips-or-test-kits-expire/">Do Pool Test Strips or Test Kits Expire?</a></li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://poolwater-pro.com/more">More</a>
                            </li>
                        </ul>
                        <form className="d-flex align-items-center gap12" role="search">
                            <a href="https://poolwater-pro.com/#contact" className="btn btn-contact">Contact Us</a>
                            <a href="https://poolwater-pro.com/login" className="btn btn-login btn-login-mobile" type="submit">Login</a>
                        </form>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Navbar;